module.exports = __webpack_public_path__ + "html/landing-top-footer_03a224f8d6fa4bdc40203d374d933c08.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing/landing-top-footer.html
// module id = 3iYK
// module chunks = 118